module.exports = __webpack_public_path__ + "img/spiral-details11.7ad02bab.png";